module.exports = __webpack_public_path__ + "images/category_lp/camera/new/assessment_achievements/5_dac985d2fc2962261d04f5eeb7ea359c.png";